export default __webpack_public_path__ + "static/media/e3.0900f480.png";